import { render, staticRenderFns } from "./ActivixIcon.vue?vue&type=template&id=1247f55e&"
import script from "./ActivixIcon.vue?vue&type=script&lang=js&"
export * from "./ActivixIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports